'use strict';

var ticky = require('ticky');

module.exports = function debounce (fn, args, ctx) {
  if (!fn) { return; }
  ticky(function run () {
    fn.apply(ctx || null, args || []);
  });
};



//////////////////
// WEBPACK FOOTER
// /app/~/contra/debounce.js
// module id = ../../../../contra/debounce.js
// module chunks = 16